import { Inject, Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad,
  Route
} from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "@app/shared/services/authentication.service";

@Injectable()
export class AuthMyProjectsService implements CanActivate, CanActivateChild, CanLoad {
  appState: any;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let url: string = state.url;
    return this.isAccessible(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return this.isLoadable(url);
  }
  isLoadable(url: string): boolean {
    return true;
  }
  isAccessible(url: string): boolean {
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/my-projects/auth-guard-my-projects.service.ts